export default "__VITE_ASSET__DNmspNWq__"